import type { NoteTakerStatus } from '@/mocks/calls';
import { MOCK_LEADS, MOCK_STAFF } from '@/mocks/shared';

/** The made-up lead's name, or the email when the lead has none. */
export const leadName = (email: string) => MOCK_LEADS.find((l) => l.email === email)?.name ?? email;

/** The made-up staff member's name. */
export const staffName = (id: string) => MOCK_STAFF.find((s) => s.id === id)?.name ?? 'Unknown';

export const NOTE_TONES: Record<NoteTakerStatus, 'ok' | 'neutral'> = { ready: 'ok', processing: 'neutral', none: 'neutral' };
